<template>
<div>
....
</div>
</template>

<script>
//this page is just an interim page that we use

// eslint-disable-next-line
import {applog} from '@/services/applog.js'

//vue page object
export default {
  name: 'blanko'
}
</script>

<style scoped>
</style>